'use client'
import * as React from 'react'
import Script from 'next/script'
import type { RegistrationSource } from '@repo/auth-utils'

import {
  GoogleOneTapWidget,
  googleOneTapScriptUrl as googleOneTapLoginScriptUrl,
} from '@repo/google-one-tap-login/widget'
import { useIsLoggedInQuery } from 'auth/hooks'
import { getCookie, deleteCookie } from 'utils/dom'

const MANAGE_SUBSCRIPTION_RETURN_COOKIE = 'cf_manage_sub_return'
const MANAGE_SUBSCRIPTION_RETURN_URL =
  '/my-account/manage-subscription/?load-compensation-options=1'

export const GlobalOneTapLogin = ({
  autoSelect = true,
  registrationSource,
}: {
  autoSelect?: boolean
  registrationSource?: RegistrationSource
} = {}) => {
  const isLoggedInQuery = useIsLoggedInQuery()
  const loggedIn = isLoggedInQuery.data
  const loading = isLoggedInQuery.isPending

  React.useEffect(() => {
    if (loggedIn && !loading) {
      const { google } = window
      if (google) {
        google.accounts.id.cancel()
      }

      if (getCookie(MANAGE_SUBSCRIPTION_RETURN_COOKIE) === '1') {
        deleteCookie(MANAGE_SUBSCRIPTION_RETURN_COOKIE)
        const alreadyOnTarget =
          window.location.pathname + window.location.search === MANAGE_SUBSCRIPTION_RETURN_URL
        if (!alreadyOnTarget) {
          window.location.href = MANAGE_SUBSCRIPTION_RETURN_URL
        }
      }
    }
  }, [loggedIn, loading])

  if (loading || loggedIn || isLoggedInQuery.isFetching) {
    return null
  }

  const redirectUrl =
    typeof window !== 'undefined'
      ? getCookie(MANAGE_SUBSCRIPTION_RETURN_COOKIE) === '1'
        ? `${window.location.origin}${MANAGE_SUBSCRIPTION_RETURN_URL}`
        : window.location.href
      : ''

  return (
    <>
      <GoogleOneTapWidget
        autoSelect={autoSelect}
        redirectUrl={redirectUrl}
        registrationSource={registrationSource}
      />
      <Script
        id="global-one-tap-login-script"
        src={googleOneTapLoginScriptUrl}
        strategy="lazyOnload"
      />
    </>
  )
}
